module.exports = __webpack_public_path__ + "static/img/slaPurpose4.feaae75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slaPurpose4.png
// module id = 9AfL
// module chunks = 2